import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import OuterFrame from "../component/outerFrame/outerFrame";
import Home from "../pages/home";
import AccessManagement from "../pages/accessManagement/AccessManagement.jsx";
// import RuleElevation from "../pages/rulePage/RuleElevationPage";
import ProductOnBoarding from "../pages/OnBoardingProduct/ProductOnBoarding";
import MainMenu from "../nav/MainMenu";
import Dashboard from "../pages/dashboard/Dashboard";
import DataMonitoring from "../pages/DataMonitoring/DataMonitoring";
import DataTrafficLights from "../pages/dataTrafficLights/DataTrafficLights";
import DataContract from "../pages/dataContract/DataContract";
import LandingPage from "../pages/dataDomain/LandingPage";
import { ProtectedRoute } from "../components/ProtectedRoute";
import Action from "../pages/ActionPage/Action";
import DataProduct from "../pages/DataProduct/DataProduct";
import Versioning from "../pages/Versioning/Versioning";
import SavedDataProduct from "../pages/DataProductSaved/SavedDataProduct";
import FeatureRedirect from "../pages/featureRedirect/FeatureRedirect";
import SubscriptionFeedback from "../component/Feedback/SubscriptionFeedback.jsx"
import SubmitFeaturePage from "../pages/submitfeature/SubmitFeaturePage.jsx";
import withEnvSwitch from "./withEnvSwitch.js";
import { MatomoProvider, createInstance } from "@datapunt/matomo-tracker-react";
import { MatomoRouteTracker } from "./Matomo/RouteTracker";
import MatomoTagManagerLoader from "./Matomo/TagManagerLoader.js";
import MatomoDelegate from './Matomo/Delegate.jsx';
import { getConfig } from "../config/envConfig";
import AuthGuard from "../services/authGaurd.js";
import { AuthProvider } from "../context/AuthContext.js";
import Main from "../component/Layout/DataContract/Viewkpi/Main.jsx";

const FeatureComponent = withEnvSwitch(FeatureRedirect, SubmitFeaturePage);

const { MATOMO_DASHBOARD_URL, MATOMO_SITE_ID, MATOMO_CONTAINER_SRC } = getConfig();
const instance = createInstance({
  urlBase: MATOMO_DASHBOARD_URL,
  siteId: MATOMO_SITE_ID,
  disabled: false, // optional, false by default. Makes all tracking calls no-ops if set to true.
  linkTracking: false, // optional, default value: true
});

function MainRoutes() {
  return (
    <MatomoProvider value={instance}>
      <BrowserRouter>
        <AuthProvider>
          <AuthGuard>
            <MatomoTagManagerLoader src={MATOMO_CONTAINER_SRC} />
            <MatomoRouteTracker />
            <MatomoDelegate />
            <Routes>
              <Route path="/" element={<Home />} />

              <Route
                path="/subscription-feedback"
                element={
                  <SubscriptionFeedback />
                }
              />
              <Route
                path="/accessManagement"
                element={
                  <ProtectedRoute allowedRoles={["Admin"]}>
                    <MainMenu
                      text1={"Snacking Data Marketplace"}
                    >
                      <AccessManagement />
                    </MainMenu>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/dataDomain"
                element={
                  <MainMenu
                    text1={"Snacking Data Marketplace"}
                    padding={false}
                  >
                    <LandingPage />
                  </MainMenu>
                }
              />

              <Route
                path="/view-kpi"
                element={
                  <MainMenu
                    text1={"Snacking Data Marketplace"}
                    padding={false}
                  >
                    <Main />
                  </MainMenu>
                }
              />

              <Route
                path="/product-onboarding"
                element={
                  <ProtectedRoute restrictedEnvs={["Prod"]}>
                    <MainMenu
                      text1={"Snacking Data Marketplace"}
                      padding={true}
                    >
                      <ProductOnBoarding />
                    </MainMenu>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/product-onboarding/:id"
                element={
                  <ProtectedRoute restrictedEnvs={["Prod"]}>
                    <MainMenu
                      text1={"Snacking Data Marketplace"}
                      padding={true}
                    >
                      <ProductOnBoarding />
                    </MainMenu>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/feature-requests"
                element={
                  <MainMenu
                    text1={"Snacking Data Marketplace"}
                    padding={true}
                  >
                    <FeatureComponent />
                  </MainMenu>
                }
              />

              <Route
                path="/feature-requests/:featureId"
                element={
                  <MainMenu
                    text1={"Snacking Data Marketplace"}
                    padding={true}
                  >
                    <FeatureComponent />
                  </MainMenu>
                }
              />

              <Route
                path="/data-traffic-lights"
                element={
                  <MainMenu
                    text1={"Snacking Data Marketplace"}
                    padding={false}
                  >
                    <DataTrafficLights />
                  </MainMenu>
                }
              />

              <Route
                path="/dashboard"
                element={
                  <MainMenu
                    text1={"Snacking Data Marketplace"}
                    padding={false}
                  >
                    <Dashboard />
                  </MainMenu>
                }
              />

              <Route
                path="/data-monitoring"
                element={
                  <MainMenu
                    text1={"Snacking Data Marketplace"}
                    padding={false}
                  >
                    <DataMonitoring />
                  </MainMenu>
                }
              />
              
              {/* Embeded route */}
              <Route
                path="/embed/data-monitoring"
                element={<DataMonitoring />}
              />

              <Route
                path="/action"
                element={
                  <MainMenu
                    text1={"Snacking Data Marketplace"}
                    padding={false}
                  >
                    <Action />
                  </MainMenu>
                }
              />

              <Route
                path="/versioning"
                element={
                  <ProtectedRoute restrictedEnvs={["Prod"]}>
                    <MainMenu
                      text1={"Snacking Data Marketplace"}
                      padding={true}
                    >
                      <Versioning />
                    </MainMenu>
                  </ProtectedRoute>
                }
              />

              <Route
                path="/versioning/:id"
                element={
                  <MainMenu
                    text1={"Snacking Data Marketplace"}
                    padding={true}
                  >
                    <Versioning />
                  </MainMenu>
                }
              />
              <Route
                path="/product-report/dashboard-view/:dashboardId"
                element={
                  <MainMenu
                    text1={"Snacking Data Marketplace"}
                    padding={false}
                  >
                    <SavedDataProduct />
                  </MainMenu>
                }
              />
              <Route
                path="/product-report/:productId"
                element={
                  <MainMenu
                    text1={"Snacking Data Marketplace"}
                    padding={false}
                  >
                    <DataProduct />
                  </MainMenu>
                }
              />

              <Route
                path="/data-contract"
                element={
                  <MainMenu
                    text1={"Snacking Data Marketplace"}
                    padding={true}
                  >
                    <DataContract />
                  </MainMenu>
                }
              />
              <Route path="/" element={<Navigate to="/login" />} />
            </Routes>
          </AuthGuard>
        </AuthProvider>
      </BrowserRouter>
    </MatomoProvider>
  );
}

export default MainRoutes;
